// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"132":"44b53b1e","310":"52a165b8","453":"a492ffeb"}[chunkId] + ".chunk.js";
};